module.exports = __webpack_public_path__ + "img/icon_help.52926872.svg";